import * as React from 'react';

import { InputFormGroupType, InputFormGroupProps, InputFormGroup } from '@admin/components/fields';

export const AptSuiteFormGroup = React.forwardRef<InputFormGroupType, InputFormGroupProps>((props, ref) => (
  <InputFormGroup type="text" id="address-aptsuite" label="Apt / Suite" ref={ref} {...props} />
));
